import React from 'react';
import { ModalContent, ModalHeader, Typography } from 'common/components';

export const Benefits = () => (
  <>
    <ModalHeader title="15 лет экспертизы" />
    <ModalContent variant="simple">
      <Typography adaptive={false} variant="m" size="body_long">
        Более 15&nbsp;лет мы&nbsp;проектируем и&nbsp;продаем окна по&nbsp;всей России.
      </Typography>
      <Typography adaptive={false} variant="m" size="body_long">
        Мы&nbsp;знаем, какие свойства должны иметь окна в&nbsp;разном климате и&nbsp;разных
        зданиях, от&nbsp;&laquo;сталинок&raquo; до&nbsp;&laquo;хрущевок&raquo; до&nbsp;современных
        загородных домов.
      </Typography>
    </ModalContent>
  </>
);
